import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Alert,
  Stack,
  Card
} from '@mui/material';
import {
  Cancel,
  ArrowBack
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { EasyCheckButton } from '../common/Controls';
import { themeUtils } from '../../theme';

const CancelContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: themeUtils.gradients.backgroundLight,
  padding: theme.spacing(3),
}));

const CancelCard = styled(Card)(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  backdropFilter: 'blur(20px)',
  borderRadius: '24px',
  padding: theme.spacing(4),
  boxShadow: `0 20px 60px rgba(37, 99, 235, 0.15)`,
  border: `1px solid ${themeUtils.colors.blue['blue-100']}`,
  maxWidth: '500px',
  width: '100%',
  textAlign: 'center',
}));

const CancelIcon = styled(Cancel)(({ theme }) => ({
  fontSize: '4rem',
  color: theme.palette.warning.main,
  marginBottom: theme.spacing(2),
}));

const PaymentCancelledPage = () => {
  const navigate = useNavigate();

  const handleReturnToSignup = () => {
    navigate('/signup');
  };

  return (
    <CancelContainer>
      <CancelCard>
        <Stack spacing={3} alignItems="center">
          <CancelIcon />
          
          <Typography variant="h4" fontWeight={700} color="warning.main">
            Payment Cancelled
          </Typography>
          
          <Typography variant="h6" fontWeight={500} color="text.secondary">
            No charges were made to your account
          </Typography>

          <Alert 
            severity="info" 
            sx={{ 
              width: '100%',
              borderRadius: 2,
              backgroundColor: 'rgba(37, 99, 235, 0.1)',
              border: '1px solid rgba(37, 99, 235, 0.2)',
            }}
          >
            <Typography variant="body1">
              Your payment was cancelled and no charges were made. 
              You can return to complete your signup whenever you're ready.
            </Typography>
          </Alert>

          <Typography variant="body2" color="text.secondary" textAlign="center">
            To access EasyCheck and start managing your cheques, 
            you'll need to complete the payment process.
          </Typography>

          <Stack direction="row" spacing={2} width="100%">
            <EasyCheckButton
              variant="outlined"
              onClick={() => navigate('/')}
              sx={{ flex: 1 }}
            >
              Home
            </EasyCheckButton>
            
            <EasyCheckButton
              variant="contained"
              startIcon={<ArrowBack />}
              onClick={handleReturnToSignup}
              sx={{
                flex: 1,
                background: themeUtils.gradients.primary,
                '&:hover': {
                  background: themeUtils.gradients.primaryDark,
                  transform: 'translateY(-2px)',
                  boxShadow: `0 12px 35px ${themeUtils.colors.blue['blue-600']}40`,
                },
              }}
            >
              Complete Signup
            </EasyCheckButton>
          </Stack>

          <Typography variant="caption" color="text.secondary">
            Need help? Contact our support team.
          </Typography>
        </Stack>
      </CancelCard>
    </CancelContainer>
  );
};

export default PaymentCancelledPage; 